import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { CuratedCategoryModel } from '@app/core/models';
import {
  ICategoryListGetRequest,
  ICuratedCategoryApiModel,
} from '@app/core/models/api';

@Injectable()
export class TagApiService {
  constructor(private http: HttpClient) {}

  getTagsByCluster(
    clusterId: number | null,
  ): Observable<Array<CuratedCategoryModel>> {
    const req: ICategoryListGetRequest = { is_tag: '1' };

    if (clusterId != null) {
      req.cluster_id = clusterId;
    }

    return this.getCuratedCategoryList(req);
  }

  getTagsByPlace(id: number): Observable<Array<CuratedCategoryModel>> {
    return this.getCuratedCategoryList({
      is_tag: '1',
      place_id: id,
    });
  }

  private getCuratedCategoryList(
    req: ICategoryListGetRequest,
  ): Observable<Array<CuratedCategoryModel>> {
    return this.http
      .get<Array<ICuratedCategoryApiModel>>(
        `${environment.API_URL}v5/categories.curated.json`,
        {
          params: new HttpParams({ fromObject: req as any }),
        },
      )
      .pipe(map(res => res.map(item => new CuratedCategoryModel(item))));
  }
}
